module.exports = __webpack_public_path__ + "static/media/Conacyt-min.f6869077.png";